import {QueryBuilderReducerActionTypeEnum, QueryBuilderReducerDispatch, QueryBuilderStateQueryRule} from "../../../../index";
import React, {FunctionComponent, useCallback, useEffect, useState} from "react";
import {TextField, TextFieldProps} from "@mui/material";

export interface QueryBuilderValueInputStringProps {
    rule: QueryBuilderStateQueryRule;
    ruleIndex: number;
    conditionIndex: number;
    disabled: boolean;
    dispatch: QueryBuilderReducerDispatch;
}

const QueryBuilderValueInputString: FunctionComponent<QueryBuilderValueInputStringProps> = ({
                                                                                                dispatch,
                                                                                                disabled,
                                                                                                rule,
                                                                                                ruleIndex,
                                                                                                conditionIndex,
                                                                                            }) => {
    const [value, setValue] = useState<string>(rule.value as string ?? "");

    /**
     * With each change in the [rule.value] prop:
     * - updates the local state.
     */
    useEffect(() => {
        setValue(rule.value as string ?? "")
    }, [rule.value]);

    /**
     * Changes the rule's value in the reducer for string types.
     */
    const changeStringValue = useCallback<Required<TextFieldProps>['onChange']>((e) => {
        setValue(e.target.value)
    }, []);

    /**
     * Commits the rule's value in the reducer for string types.
     */
    const commitStringValue = useCallback<Required<TextFieldProps>['onBlur']>((e) => {
        setValue(e.target.value)
        dispatch({
            type: QueryBuilderReducerActionTypeEnum.ChangeValue,
            payload: {
                conditionIndex: conditionIndex,
                ruleIndex: ruleIndex,
                value: e.target.value,
            },
        })
    }, [dispatch, conditionIndex, ruleIndex]);

    return (
        <>
            <TextField
                fullWidth
                label={'String Value'}
                variant={'outlined'}
                size={'small'}
                disabled={rule.displayEmptyValuesOnly || disabled}
                value={value ?? ""}
                onChange={changeStringValue}
                onBlur={commitStringValue}
            />
        </>
    );
};


export default QueryBuilderValueInputString;
